import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
@Component({
  selector: 'app-blog-tool',
  imports: [RouterLink],
  templateUrl: './blog-tool.component.html',
  styleUrl: './blog-tool.component.css'
})
export class BlogToolComponent {

}
